import { pushToDataLayer } from "@lib/gtm/dataLayer";
import LocalStorageWithFallback from "@lib/cookieMessage/localStorageWithFallback";

export enum ACTION_FIELD_LIST {
    SEARCH_RESULTS = 'Suchergebnisseite',
}

export const SERVICES_SELECTED = 'services_selected';

export enum CURRENCY_CODE {
    EUR = 'EUR',
}

interface TrackableProduct {
    name: string
    id: string
    price: string
    brand: string
}

interface TrackableTransaction {
    transactionId: string
    transactionAffiliation: string
    transactionTotal: number
    transSku: number
    transName: string
    transCategory: string
    transPrice: number
    quantity: string
    isBinding: boolean
    appointmentId: string,
    bookingId: number,
}

export interface IKeyable {
  [key: string]: any
}

declare global {
  interface Window {
    // @ts-ignore
    dataLayer: Array<keyable>;
  }
}

export class TrackingHelper {
    public static trackProductClick(
        { name, id, price, brand }: TrackableProduct,
        currencyCode: CURRENCY_CODE = CURRENCY_CODE.EUR,
        actionFieldList: ACTION_FIELD_LIST = ACTION_FIELD_LIST.SEARCH_RESULTS
    ): void {
        pushToDataLayer({
            event: 'productClick',
            eventData: {
                label: '',
                action: '',
                category: '',
            },
            ecommerce: {
                currencyCode,
                click: {
                    actionField: {
                        list: actionFieldList,
                    },
                    products: [
                        {
                            name,
                            id,
                            price,
                            brand,
                            category: '',
                            variant: ''
                        }
                    ]
                }
            }
        });
    }

    public static trackSelectedServices(
        storageKey: string
    ): void {
        const localStorageWithFallback = new LocalStorageWithFallback();
        const storageData = localStorageWithFallback.get(storageKey);

        if (!storageData) {
            return;
        }

        const eventData = JSON.parse(storageData);

        pushToDataLayer({
            event: SERVICES_SELECTED,
            ...eventData
        });

        localStorageWithFallback.remove(storageKey);
    }

    public static trackFinishEcommerce(
        eventData: string
    ): void {
        if (!eventData) {
            return;
        }
        pushToDataLayer(JSON.parse(eventData));
    }

    public static trackFinishTransaction(
        { transactionId, transactionAffiliation, transactionTotal, transSku, transName, transCategory, transPrice, quantity, isBinding, appointmentId, bookingId }: TrackableTransaction
    ): void {
        pushToDataLayer(
            {
                'transactionId': transactionId,
                'bookingId': bookingId,
                'transactionAffiliation': transactionAffiliation,
                'transactionTotal': transactionTotal,
                'transactionTax': 0,
                'transactionShipping': 0,
                'transactionProducts': [
                    {
                        'sku': transSku,
                        'name': transName,
                        'category': transCategory,
                        'price': transPrice,
                        'quantity': quantity,
                        'appointmentId': appointmentId
                    }
                ],
                'event': isBinding ? 'kaufenFinal' : 'anfrageFinal'
            }
        )
    }
}
